module.exports = __webpack_public_path__ + "static/sui-table-stacked-1e761f7661354f52d359785aa43b0c18.gif";